import React, { useCallback, useEffect, useState } from 'react';
import { v1 as uuidv1 } from 'uuid';
import AddIcon from '../../components/Icons/AddIcon';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import DeleteMinus from '../../components/Icons/DeleteMinus';
import { isEmpty } from 'lodash';
import { setOneTimeOrderAction, setOrderDataAction } from '../../redux/Actions/CreateOrderActions';
import { useDispatch, useSelector } from 'react-redux';
import { amountCheckFn, numberConverter } from '../../utils/commonUtil';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { getServicesAndPricingApi } from '../../redux/Reducers/commonApis';
import toast from 'react-hot-toast';
import { setGroupAvailableServicesAction, setGroupSelectedServicesAction } from '../../redux/Actions/GroupActions';
function GroupServices() {
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const { allServiceAddresses } = useSelector((state) => state.serviceAddresses);
  const { availableServices } = useSelector((state) => state.group);
  const tenant = import.meta.env.VITE_TENANT_NAME;
  const [selectedServices, setSelectedServices] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(false);
  const onDefaultQuantiyChange = (id) => {
    if (tenant === 'pushlaundry') {
      switch (id) {
        case 13:
          return 15;
        default:
          return 1;
      }
    } else {
      return 1;
    }
  };
  const isServiceSelected = (id) => selectedServices?.some((service) => service?.service_id === id);
  const onSelectService = (serviceSelected) => {
    if (selectedServices?.find((service) => service?.service_id === serviceSelected?.id)) {
      if (isServiceSelected(serviceSelected?.id)) {
        const newServices = selectedServices?.filter((service) => service?.service_id !== serviceSelected?.id);
        // dispatch(setOrderDataAction({ selectedServices: newServices }));
        setSelectedServices(newServices);
      } else {
        const newService = {
          id: uuidv1(),
          service_id: serviceSelected?.id,
          quantity: onDefaultQuantiyChange(serviceSelected?.id),
        };
        // dispatch(setOrderDataAction({ selectedServices: [...selectedServices, newService] }));
        setSelectedServices([...selectedServices, newService]);
      }
    } else {
      setSelectedServices([
        ...selectedServices,
        { service_id: serviceSelected?.id, quantity: onDefaultQuantiyChange(serviceSelected?.id) },
      ]);
    }
  };
  const onIncrementorDecrementFn = (type, serviceListId) => {
    const newServices = selectedServices?.map((service) => {
      if (service?.service_id === serviceListId) {
        if (type === 'increment') {
          return { ...service, quantity: service?.quantity + 1 };
        } else if (type === 'decrement' && service?.quantity > 1) {
          return { ...service, quantity: service?.quantity - 1 };
        }
      }
      return service;
    });
    dispatch(setOrderDataAction({ selectedServices: newServices }));
  };
  const onQuanityChangeFn = (text, serviceListId) => {
    const quantity = numberConverter(text);
    if (quantity === 0) {
      const newServices = selectedServices?.filter((service) => service?.service_id !== serviceListId);
      // dispatch(setOrderDataAction({ selectedServices: newServices }));
      setSelectedServices(newServices);
      toast.error('Quantity cannot be zero');
      return;
    } else {
      //serviceListId is in selectedServices array return with service and add quantity
      if (selectedServices?.some((service) => service?.service_id === serviceListId)) {
        const newServices = selectedServices?.map((service) => {
          if (service?.service_id === serviceListId) {
            return { ...service, quantity };
          }
          return service;
        });
        setSelectedServices(newServices);
      } else {
        const newService = {
          id: uuidv1(),
          service_id: serviceListId,
          quantity,
        };
        setSelectedServices([...selectedServices, newService]);
      }

      // const newServices = selectedServices?.map((service) => {
      //   if (service?.service_id === serviceListId) {
      //     return { ...service, quantity };
      //   }
      //   return service;
      // });
      // dispatch(setOrderDataAction({ selectedServices: newServices }));
    }
  };
  useEffect(() => {
    if (!isEmpty(availableServices)) {
      if (!isEmpty(selectedServices)) {
        setSelectedServices(selectedServices);
      } else {
        const newService = {
          id: uuidv1(),
          service_id: availableServices && availableServices[0]?.id,
          quantity: onDefaultQuantiyChange(availableServices[0]?.id),
        };
        setSelectedServices([newService]);
      }
    }
  }, [availableServices]);

  // useEffect(() => {
  //   dispatch(setOrderDataAction({ selectedServices: selectedServices, orderIsRush: { value: false } }));
  // }, [selectedServices]);

  // useEffect(() => {
  //   dispatch(setOrderDataAction({ orderPreferences: currentPreferences }));
  // }, [currentPreferences]);

  React.useEffect(() => {
    // serviceUpdateFn(selectedServices);
    dispatch(setGroupSelectedServicesAction(selectedServices));
  }, [selectedServices]);

  const getServicesAndPricingFn = (id) => {
    setServicesLoading(true);
    const response = getServicesAndPricingApi(id, 'group');
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        const services = res?.data?.map((service) => {
          return {
            service: service?.name,
            id: service?.id,
            unit: service?.unit_type,
            client_fee: service?.client_fee,
            priotity_fee: service?.priority_fee,
            description: service?.description,
            image: service?.image?.absolute_url || null,
          };
        });
        setServicesLoading(false);
        dispatch(setGroupAvailableServicesAction(services || []));
      } else {
        setServicesLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  useEffect(() => {
    allServiceAddresses?.[0]?.id && getServicesAndPricingFn(allServiceAddresses?.[0]?.id);
  }, [allServiceAddresses?.[0]?.id]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  return (
    <div className='col-span-full flex flex-col  sm:col-span-8'>
      {/* <header className='flex items-center pb-3'>
        <h5 className='go-heading-18'>Services</h5>
      </header>
      <hr className='go-hr-dashed '></hr> */}
      {servicesLoading ? (
        <Loader text='loading services...' classes=' h-96' bg={true} />
      ) : availableServices?.length === 0 ? (
        <NoData text='No services available' classes='h-96' />
      ) : (
        <section>
          <div className=' grid grid-cols-1 gap-4'>
            {availableServices?.map((service) => (
              <div
                key={service?.id}
                onClick={() => onSelectService(service)}
                className={classNames(
                  isServiceSelected(service?.id) ? 'border-client-300' : 'border-gray-100',
                  ' border-3 relative flex cursor-pointer justify-between rounded-lg bg-white p-2'
                )}
              >
                <div className='flex flex-row'>
                  <div className='flex w-6'>
                    <input
                      type='checkbox'
                      id={service?.id}
                      name={service?.id}
                      onChange={() => onSelectService(service)}
                      checked={isServiceSelected(service?.id)}
                      className={classNames(
                        isServiceSelected(service?.id) ? 'text-client-300' : 'text-slate-200',
                        ' h-4 w-4 rounded-full ring-0'
                      )}
                    />
                  </div>
                  {/* {!isServiceSelected(service?.id) && ( */}
                  <div className='flex w-14 justify-center'>
                    <img src={service?.image} alt={service?.service} className='h-12 w-12' />
                  </div>
                  {/* )} */}
                  <div className='flex flex-col space-y-1'>
                    <label className='go-textblack-15 cursor-pointer'>{service?.service}</label>
                    <span className='go-textnormal-13'>{`${amountCheckFn(service?.client_fee)} per ${
                      service?.unit
                    }`}</span>
                    {isServiceSelected(service?.id) && <div className='mt-2 flex'></div>}
                  </div>
                </div>
                <div className='flex flex-col items-center'>
                  <input
                    type='number'
                    id={service?.id}
                    className='go-inputtext-15 h-10 w-12 p-1 text-center'
                    value={selectedServices?.find((s) => s?.service_id === service?.id)?.quantity?.toString() || ''}
                    onChange={(e) => onQuanityChangeFn(e?.target?.value, service?.id)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span className='go-textnormal-10'>Quantity</span>
                </div>
                {/* {isServiceSelected(service?.id) && (
                  <div className='flex grow items-end justify-end'>
                    <img src={service?.image} alt={service?.service} className='h-20  ' />
                  </div>
                )} */}
              </div>
            ))}
          </div>
          {isEmpty(selectedServices) && (
            <p className='mt-4 text-center text-red-500'>Please select at least one service</p>
          )}
          {/* <hr className='go-hr-dashed mt-8 mb-5 hidden sm:block'></hr>
          <div className='grid gap-0 sm:gap-4'>
            <div className=''>
              <label htmlFor='preferences' className='go-label-16'>
                Preferences
              </label>
              <textarea
                id='preferences'
                className='form-textarea go-inputtext-16'
                rows='4'
                required
                value={currentPreferences}
                onChange={(e) => setCurrentPreferences(e?.target?.value)}
                onBlur={(e) => setCurrentPreferences(e?.target?.value)}
              ></textarea>
            </div>
          </div> */}
        </section>
      )}
    </div>
  );
}

export default GroupServices;
